module.exports = __webpack_public_path__ + "img/charles_antoine_giuliani_rounded_gray.225a7018.jpg";